// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d9de2706","236":"cb90e590","703":"a2d2cdbd","787":"d6fba6fa"}[chunkId] + ".chunk.js";
};